import classnames from "classnames";
import PropTypes from "prop-types";
import { ErrorMessage } from "../error-message";
import styles from "./styles";

export const TextField = ({
  className,
  initialValue,
  ariaLabel,
  disabled,
  onChange,
  errorMessage,
  id,
  placeholder,
  autocomplete,
  required,
  description,
  hasError,
}) => {
  return (
    <>
      <input
        className={classnames(
          styles.input,
          className,
          hasError && styles.inputError
        )}
        aria-label={ariaLabel}
        disabled={disabled}
        value={initialValue}
        onChange={onChange}
        id={id}
        placeholder={placeholder}
        autoComplete={autocomplete}
        aria-required={required}
        type="text"
      />
      {hasError && <ErrorMessage message={errorMessage} />}
      {description && (
        <span className={classnames(styles.description, "app_leavesden2")}>
          {description}
        </span>
      )}
    </>
  );
};

TextField.propTypes = {
  initialValue: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
};

TextField.defaultProps = {
  className: "",
  initialValue: "",
  errorMessage: "",
  id: "",
  placeholder: "",
  autocomplete: "on",
  description: "",
  required: false,
  hasError: false,
};
